module.exports = __webpack_public_path__ + "static/img/14.213fd5c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/14.png
// module id = VFYv
// module chunks = 0